var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "en.svg",
    clipPath: "url(#clip0_2211_35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2211_35",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 12
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.558594 0H18.5586V11.998H0.558594V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2211_35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.5586 0H0.558594V11.998H18.5586V0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5586 0V1.25L14.0326 4.2665L12.9926 4.9595L11.4331 5.999L12.9931 7.039L18.5586 10.748V11.9975H16.6836L11.2916 8.4035L10.5986 7.941L9.55859 7.2485L8.51859 7.9415L7.82559 8.404L2.43309 11.998H0.558594V10.748L5.08459 7.7315L6.12459 7.0385L7.68409 5.999L6.12409 4.959L5.08459 4.2665L0.558594 1.2495V0H2.43359L7.82559 3.594L8.51859 4.0565L9.55859 4.7495L10.5986 4.0565L11.2916 3.594L16.6841 0H18.5586Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3676 4.9595L10.8076 5.999L12.3676 7.039L13.4076 7.7315L18.5586 11.1655V11.998H17.3096L11.2916 7.9865L10.5986 7.5245L9.55859 6.8315L8.51859 7.5245L7.82559 7.9865L1.80759 11.998H0.558594V11.1655L5.71009 7.7315L6.75009 7.0385L8.30959 5.999L6.74959 4.959L5.71009 4.2665L0.558594 0.8325V0H1.80759L7.82559 4.0115L8.51859 4.4735L9.55859 5.1665L10.5986 4.4735L11.2916 4.0115L17.3096 0H18.5586V0.8325L13.4071 4.2665L12.3676 4.9595Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2916 7.732V11.998H7.82559V7.732H0.558594V4.2665H7.82559V0H11.2916V4.2665H18.5586V7.7315L11.2916 7.732Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5986 7.0385V11.998H8.51859V7.0385H0.558594V4.96H8.51859V0H10.5986V4.96H18.5586V7.039H10.5986V7.0385Z",
    fill: "#FF4B55"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2211_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 12,
    fill: "white",
    transform: "translate(0.558594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.2de8b56bbf6f4bff7d592f1a6f25a04f.svg";
export { ForwardRef as ReactComponent };